export default __webpack_public_path__ + "static/media/Hoshang_Shah_s_Tomb_01.5fb0c94a.jpg";